
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { AuthModel } from '../../_models/auth.model';
import { DbsForMenu } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class HttpServicsService {
  httpHeaders: HttpHeaders;
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  private DbsToken = `${environment.appVersion}-Dbd`;
  constructor(


    private http: HttpClient,
    private router: Router,

  ) { }


  getDbManager() {
    return this.getmethod<DbManager[]>(`/DBManager/GeetAllDBs`);
  }

  CrateProductService(dto){
    return this.postmethod<DbManager[]>('/ProductAndService',dto);
  }

  private delmethod<returnModel>(url: string) {
    return this.http.delete<get<returnModel>>(`${environment.apiUrl}${url}`, {
      headers: { Authorization: `Bearer ${this.getAuthFromLocalStorage().access_token}` , tenant :this.getDbsFromLocalStorage() ?this.getDbsFromLocalStorage().find(p=>p.IsCelected == true).DId :""},
      
    });
  }
  private getmethod<returnModel>(url: string) {
    return this.http.get<get<returnModel>>(`${environment.apiUrl}${url}`, {
      headers: { Authorization: `Bearer ${this.getAuthFromLocalStorage().access_token}`, tenant :this.getDbsFromLocalStorage() ?this.getDbsFromLocalStorage().find(p=>p.IsCelected == true).DId :""},
      
    });
  }
  private postmethod<returnModel>(url: string, dto) {
    console.log(`${environment.apiUrl}${url}`);

    return this.http.post<get<returnModel>>(`${environment.apiUrl}${url}`, dto, {
      headers: { Authorization: `Bearer ${this.getAuthFromLocalStorage().access_token}`, tenant :this.getDbsFromLocalStorage() ?this.getDbsFromLocalStorage().find(p=>p.IsCelected == true).DId :""},
      
    });
  }
  getDbsFromLocalStorage(): DbsForMenu[] {
    try {
      const authData = JSON.parse(
        localStorage.getItem(this.DbsToken)
      );
      return authData;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
  private getAuthFromLocalStorage(): AuthModel {
    try {
      const authData = JSON.parse(
        localStorage.getItem(this.authLocalStorageToken)
      );
      return authData;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
}
export interface get<key> {
  data: key;
  isSuccess: boolean;
  statusCode: number;
  message: string;
}
export class DbManager {
  name: string;
  tId: string;
}
